import React, {ReactNode} from "react";

import {useNavigateWithParams} from "../../../../util/NavUtils";

type ProfileChecklistItemProps = {
  title: string,
  index: number, // To create a numbered list
  description: ReactNode,
  completed: boolean,
  link: string
  todos?: string[]
}

export const ProfileChecklistItem = (props: ProfileChecklistItemProps) => {
  
  const navigate = useNavigateWithParams()
  
  return <div onClick={() => navigate(props.link)} className={'CompleteProfileChecklistItem'}>

    <div className={props.completed ? 'CompleteProfileChecklistButton CompleteProfileChecklistButtonCompleted' : 'CompleteProfileChecklistButton'}>
      {props.completed && <>✓</>}
    </div>

    <div className={'CompleteProfileChecklistText'}>
      <div style={{fontWeight: 'bold'}}>{props.index + 1}. {props.title}</div>
      <div>{props.description}</div>
      {!!(props.todos?.length) && <div style={{height: 5}}/>}
      {props.todos?.map(todo => <div className={'ColorRed'}> - {todo}</div>)}
    </div>

  </div>
}
